import { render } from "./AposRelationshipEditor.vue?vue&type=template&id=4232c0f0"
import script from "./AposRelationshipEditor.vue?vue&type=script&lang=js"
export * from "./AposRelationshipEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"piece-type/ui/apos/components/AposRelationshipEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4232c0f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4232c0f0', __exports__)) {
    api.reload('4232c0f0', __exports__)
  }
  
  module.hot.accept("./AposRelationshipEditor.vue?vue&type=template&id=4232c0f0", () => {
    api.rerender('4232c0f0', render)
  })

}


export default __exports__